import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { getFormattedDate } from '../../utils/date-utils/dateUtils';
import { getPageName } from '../../utils/pageName';
import styles from './legislation_card.module.scss';
import { LegislationCardVersionChipSelection } from './LegislationCardVersionChipSelection';
import { LegislationPopoverInfos } from '../legislation.types';
import {
  VIGUEUR,
  VIGUEUR_ETEN,
  VIGUEUR_NON_ETEN,
} from '../../../../shared/constants/legislationArticleApplicability';

type Props = {
  legislation: LegislationPopoverInfos;
};

function getStartingDate(startingDate: string) {
  return `Version du ${getFormattedDate(startingDate)}`;
}
function getEndingDate(endingDate: string | null) {
  if (endingDate) {
    return ` au ${getFormattedDate(endingDate)}`;
  }
  return '';
}

export const LegislationCardVersion: React.FC<Props> = ({
  legislation,
}: Props) => {
  const intl = useIntl();
  const pageName: string = getPageName();
  const {
    startingDate,
    isTheOnlyOneVersion,
    endingDate,
    applicability,
  } = legislation;
  const isApplicable =
    applicability === VIGUEUR ||
    applicability === VIGUEUR_NON_ETEN ||
    applicability === VIGUEUR_ETEN;
  return (
    <>
      <div className={styles.container}>
        <LegislationCardVersionChipSelection legislation={legislation} />
        {pageName === 'Decision' && !isApplicable && (
          <span className={styles.complement}>
            <FormattedMessage id="legislation/components/card/LegislationCardVersion.tsx/1" />
          </span>
        )}
      </div>
      {startingDate && (
        <div className={styles.dates}>
          {isTheOnlyOneVersion
            ? `Créé le ${getFormattedDate(startingDate)}`
            : `${getStartingDate(startingDate)}${getEndingDate(endingDate)}`}
          {isApplicable &&
            ` · ${intl.formatMessage({
              id: 'legislation/components/card/LegislationCardVersion.tsx/2',
            })}`}
        </div>
      )}
    </>
  );
};
